import { useUserData } from './useUserData';
import { getUserIdFromUserData } from './utils';

export const useUserId = () => {
    const { userData } = useUserData();

    return getUserIdFromUserData(userData);
};
